import React from 'react';
import { HollowDotsSpinner } from "react-epic-spinners";

function Spinner(props) {
    const {size, color} = props; 
    return (
        <HollowDotsSpinner size={!size ? 20 : size} color={!color ? "#000" : color == '#4D627E' ? "#4D627E" : color} loading={true} />
    );
}

export default Spinner;